export default "__VITE_ASSET__B$uiY$$V__"